import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CommonPopUp from './common-popup';

const GuideToVerifyContent = () => {
    const [applyRestrictionPopup, setApplyRestrictionPopup] = useState(false);
    const handleSafariBlockIssue = () =>{
        setApplyRestrictionPopup(true)
    }
    const handleSafariBlockIssueClose = () => {
        setApplyRestrictionPopup(false)
    }
  return (
    <>
             
               <strong className='d-block mb-1' style={{ fontSize: '18px', fontWeight:'bold' }}>iOS Users</strong>
                <p className='d-block mb-1'>In case of <strong>Safari</strong> browser, you might need to allow pop-ups. <span onClick={handleSafariBlockIssue} className='cursor-pointer fs-14' style={{color:'#00aae5', textDecoration:'underline'}}>watch video</span> <br/>Steps to follow:</p>
              <ol className='ps-4 mb-0'>
                  <li>Go to Settings, search Safari.</li>
                  <li>Under <strong>General</strong>, turn off <strong>Block Pop-ups.</strong></li>
              </ol>
              <p className='mb-4'>You can now continue to connect your social account.</p>
              <strong className='d-block mb-1' style={{ fontSize: '18px', fontWeight:'bold' }}>Instagram</strong>
              <p className='d-block mb-3'>Your Instagram account should either be Professional, Creator or Business account.</p>

              <strong className='d-block mb-1 mt-3' style={{ fontSize: '18px', fontWeight:'bold' }}>YouTube</strong>
              <p className='d-block mb-4'>You should have a YouTube channel connected to your Google account.</p>
              <p>If you still face any issues kindly connect with us at influencer.support@clanconnect.ai.</p>
              <Link to='https://api.whatsapp.com/send?phone=9289315858' target='_blank'>
                  <button className='btn btn-outline-primary btn-whatsapp'><WhatsAppIcon style={{ color: '#fff' }} /> Chat with us</button></Link>
          <CommonPopUp
              modalTitle="How to turn off Block Pop-ups in Safari"
              modalContent=""
              openModal={applyRestrictionPopup}
              onClose={handleSafariBlockIssueClose}
              className="modal-medium mx-auto safari-video-block"
          >
              <div className='mb-4'>
                <video style={{aspectRatio:'1/1'}} width="100%" controls>
                      <source src="https://clanconnect.s3.ap-south-1.amazonaws.com/static_images/app-clanconnect/videos/guide-to-connect.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                </video>
              </div>
          </CommonPopUp>
      </>
      
  )
}

export default GuideToVerifyContent